<template>
    <section id="items">
        <SiteHeader></SiteHeader>
            <div class="wrapper">
                <div class="admin-panel">
                    <div class="container">
                        <div class="row height-100vh height-sm-0">
                            <AccountSidebar></AccountSidebar>
                            <div class="main col-12 col-md-10 pl-2 pl-sm-5 pt-5">
                                <router-view />
                                <SiteFooter></SiteFooter>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </section>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import AccountSidebar from '@/components/AccountSidebar.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
    name: 'Account',
    metaInfo: {
        title: 'Account'
    },
    components: {
        SiteHeader,
        AccountSidebar,
        SiteFooter
    }
}
</script>